import { useCurrentUser } from 'providers/UserProvider';
import { usePlanApiData } from './usePlanApiData';
import { ApiPlanRepository } from 'services/api/plan/ApiPlanRepository';

const apiPlanRepository = new ApiPlanRepository();

export const useCurrentUserPlanApiData = () => {
  const { data: currentUser, isLoading: isCurrentUserLoading } = useCurrentUser();
  const { planData, isLoading: isPlanLoading } = usePlanApiData({
    planRepository: apiPlanRepository,
    accountId: currentUser?.accountId,
    enabled: !!currentUser?.accountId,
  });

  return {
    data: planData,
    isLoading: isPlanLoading || isCurrentUserLoading,
  };
};
